import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'

import { TradeInput } from '../../../../../TradeInput'

import { useCancelOrderForm } from './model'
import s from './styles.module.scss'

const TRACK_VALUES = [
  { value: 5, name: '5%' },
  { value: 10, name: '10%' },
  { value: 25, name: '25%' },
  { value: 50, name: '50%' },
  { value: 75, name: '75%' },
  { value: 100, name: '100%' },
]

export const AmountToClose = ({ pnl, currency }: { pnl: number; currency: string }) => {
  const { register, error, currentPercentOfAmount, targetPnl, setTargetAmountByPercent } = useCancelOrderForm(pnl)

  return (
    <div className={s.container}>
      <div className={s.title}>Amount to Close</div>
      <TradeInput
        type="number"
        showControls
        {...register('targetAmount', { valueAsNumber: true })}
        onUpdateValue={() => {}}
        error={error}
      />
      <div className={s.perCentTrackContainer}>
        {TRACK_VALUES.map((item) => (
          <div className={s.tackSecment} key={item.value} onClick={() => setTargetAmountByPercent(item.value)}>
            <div className={cn(s.bar, item.value === currentPercentOfAmount && s.active)} />
            <div className={cn(s.value, item.value === currentPercentOfAmount && s.active)}>{item.name}</div>
          </div>
        ))}
      </div>
      <div className={s.targetPnl}>
        <div className={s.leftPart}>Realised profit</div>
        <div className={cn(s.value, pnl < 0 ? s.negative : s.positive)}>
          {getValueWithCurrency(currency, targetPnl)}
        </div>
      </div>
    </div>
  )
}
